import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { DomainsService } from '../services/domains.service';
import { DomainPaginateInterface } from '../interfaces/dto/domain-paginate-interface';

@Injectable({
  providedIn: 'root',
})
export class DomainsResolver {
  constructor(private readonly domainService: DomainsService) {}

  resolve(): Observable<DomainPaginateInterface> {
    const domains = this.domainService.getDomainsSessionStorage();
    if (domains.values.length == 0) {
      return this.domainService.getDomains();
    }
    return of(domains);
  }
}
